import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=4efd0f0c&scoped=true"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./UserProfileDialog.vue?vue&type=style&index=0&id=4efd0f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd0f0c",
  null
  
)

export default component.exports